export default {
    HOURS: 1,
    DAYS: 2,
    WEEKS: 3,
}
